import { BerlinThemeProvider } from "@src/appV2/redesign/theme/ThemeProvider";

import { MobileCaseDetailContainer } from "./MobileCaseDetailContainer";

export function MobileCaseDetailPage() {
  return (
    <BerlinThemeProvider>
      <MobileCaseDetailContainer />
    </BerlinThemeProvider>
  );
}
